import clone from 'lodash/clone';
import { UnleashClient } from 'unleash-proxy-client';

export const getters = {
  isCreditSnapIntegrationEnabled: state => state.ap_1225_enable_credit_snap_integration,
  isPodiumChatWidgetEnabled: state => state.ft_929_enable_podium_chat_widget,

  currentFeatureFlagStates: state => clone(state),
  allFeatureFlagNames: state => Object.keys(state),

  client: () => {
    return new UnleashClient({
      appName: 'FastTrack',
      clientKey: process.env.UNLEASH_CLIENT_KEY,
      environment: process.env.APP_ENV,
      url: process.env.UNLEASH_URL
    });
  }
};
